export const DynamicFromDataType = {
  PICKLIST: "picklist",
  DATE: "date",
  DATETIME_LOCAL: "datetime-local",
  DATETIME_LOCAL_RANGE: "datetime-local-range",
  DATE_RANGE: "date-range",
  TEXT: "text",
  NUMBER: "number",
  BOOLEAN: "boolean",
  RADIO: "radio",
  MULTI_SELECT: "multi-select",
  SELECT: "select",
  CHIP_INPUT: "chip-input",
  TEXTAREA: "textarea",
  CRON: 'cron'
}
export type DynamicFromDataType = typeof DynamicFromDataType[keyof typeof DynamicFromDataType];
